import React, { useEffect, useRef, useState } from 'react'
import { ReactComponent as Person } from './person.svg'
import { ReactComponent as PersonFilled } from './personfilled.svg'

import { ReactComponent as TickIcon } from './Tick.svg'
import { Spacer, Truncate, Button } from '@cleartrip/bento'
import OutsideClickHandler from 'lib/OutsideClickHandler'

import Dropdown from './Dropdown'
import Travellers from './travellers'

const TravellerAndClass = props => {
    const { query, setQuery, activeFare } = props
    const [clickedItem, setClickedItem] = useState(false)
    const [active, setActive] = useState(false)
    const selectedClassName = {
        Economy: 'Economy',
        Business: 'Business class',
        First: 'First class',
        ['Premium Economy']: 'Premium economy'
    }

    function toggleFn() {
        setClickedItem(null)
    }
    function setClass(selectedclass) {
        setQuery({
            ...query,
            class: selectedclass
        })
    }
    const tripTypeDropdown = (
        <div
            key={'travellerAndClass'}
            value={'travellerAndClass'}
            onClick={() => {}}
            className="ls-reset br-4 w-100p  dropdown__item c-neutral-900 "
            style={{ paddingTop: '12px', paddingBottom: '24px', cursor: 'default' }}
        >
            <div style={{ width: '360px' }}>
                <Travellers urlParam={query} query={query} setQuery={setQuery} activeFare={activeFare} />
                <div className="mt-6 px-3">
                    <div
                        className={`br-16 ${
                            query.class === 'Economy' ? 'bg-dropdown c-blue b-selected-class-homepage' : ' b-grey'
                        } py-1 px-3 lh-24 fs-3 d-inline-block c-pointer`}
                        onClick={() => {
                            setClass('Economy')
                        }}
                    >
                        Economy
                    </div>

                    <div
                        className={`br-16 ${
                            query.class === 'Business' ? 'bg-dropdown c-blue b-selected-class-homepage' : ' b-grey'
                        } py-1 px-3 lh-24 fs-3 d-inline-block ml-4 mr-4 c-pointer`}
                        onClick={() => {
                            setClass('Business')
                        }}
                    >
                        Business class
                    </div>
                    <div
                        className={`br-16 ${
                            query.class === 'First' ? 'bg-dropdown c-blue b-selected-class-homepage' : ' b-grey'
                        } py-1 px-3 lh-24 fs-3 d-inline-block c-pointer`}
                        onClick={() => {
                            setClass('First')
                        }}
                    >
                        First class
                    </div>
                    <div
                        className={`br-16 ${
                            query.class === 'Premium Economy' ? 'bg-dropdown c-blue b-selected-class-homepage' : ' b-grey'
                        } py-1 px-3 lh-24 fs-3 d-inline-block mt-3 c-pointer`}
                        onClick={() => {
                            setClass('Premium Economy')
                        }}
                    >
                        Premium economy
                    </div>
                </div>
            </div>
        </div>
    )

    const getLabel = () => {
        return (
            <>
                <div className="flex flex-middle">
                    {active ? <PersonFilled /> : <Person />}
                    <span className="fw-500 fs-4 ml-2" style={{ lineHeight: '24px' }}>
                        {`${query.adults} ${query.adults > 1 ? 'Adults' : 'Adult'}${
                            query.childs ? `, ${query.childs} ${query.childs > 1 ? 'Children' : 'Child'}` : ''
                        }${query.infants ? `, ${query.infants} ${query.infants > 1 ? 'Infants' : 'Infant'}` : ''}, ${
                            selectedClassName[query.class]
                        }`}
                    </span>
                </div>
            </>
        )
    }
    return (
        <div style={{ marginLeft: '48px' }}>
            <Dropdown toggle={clickedItem === 'tripType'} toggleFn={toggleFn} active={active} setActive={setActive}>
                <Dropdown.Select
                    className="c-neutral-900"
                    placeHolder="Trip type"
                    label={getLabel()}
                    height={40}
                    border={false}
                    style={{ borderStyle: 'hidden' }}
                />
                <Dropdown.Menu>{tripTypeDropdown}</Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default TravellerAndClass
